import { meterCatalogApi } from "@/lib/api"
import type { ApiResponseMeterCatalogSnapshotDTO, MeterCatalogSnapshotDTO } from "@/gen/api"
import { useQuery } from "@tanstack/react-query"

const useGetMeterInfoSnapshot = (councilCode: string) => {
  return useQuery({
    queryKey: [useGetMeterInfoSnapshot.QUERY_KEY, councilCode],
    enabled: councilCode.trim().length > 0,
    queryFn: async () => {
      const response = await meterCatalogApi.snapshot(councilCode.trim())
      return (response.data as ApiResponseMeterCatalogSnapshotDTO).data as MeterCatalogSnapshotDTO
    },
  })
}

useGetMeterInfoSnapshot.QUERY_KEY = "meter-info-snapshot"

export default useGetMeterInfoSnapshot
